// extracted by mini-css-extract-plugin
var _1 = "RentalPortalViewRegimeControlOption-moduleactive__fovcx";
export { _1 as "active" }
